<script lang="ts" setup>
import { onMounted, ref } from 'vue';

const emit = defineEmits<{
  (e: 'toggleOverlay', value: boolean): void
}>();

const onCloseOverlay = () => {
  emit('toggleOverlay', false);
};

const closeButton = ref(null);

onMounted(() => {
    (closeButton.value! as HTMLElement).focus();
});

window.addEventListener('keydown', (e) => {
  if(e.key === 'Escape') {
    onCloseOverlay();
  }
});
</script>


<template>
  <div class="info-overlay">
    <div class="info-overlay__content">
      <h2>Hinweise zum Datenschutz</h2>
      <p>
        Wir speichern deine E-Mail-Adresse zum Zweck der Kontaktaufnahme. Wir teilen die Informationen nicht mit Dritten
        und löschen Sie im Anschluss an die Kontaktaufnahme umgehend.
      </p>
      <p>
        Unser Webserver speichert im Rahmen des E-Mail-Versands Logdateien mit den Zugriffen und
        den IP-Adressen der Zugreifenden. Abgesehen davon werden keine Daten erhoben, gespeichert oder ausgewertet.
      </p>
      <button class="button" v-on:click="onCloseOverlay" ref="closeButton">Schließen</button>
      <button class="close" v-on:click="onCloseOverlay">&times;</button>
    </div>
  </div>
</template>


<style lang="scss" scoped>
@import '@/assets/scss/colors.scss';
@import '@/assets/scss/buttons.scss';

.info-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: $color-dark-transparent;

  &__content {
    position: absolute;
    width: 720px;
    height: auto;
    max-width: 90%;
    max-height: 90%;
    background: $color-light;
    padding: 2em;
    overflow: visible;

    p {
      margin-bottom: 1em;

      a {
        text-decoration: underline;
      }

      &:last-of-type {
        margin-bottom: 2em;
      }
    }

    button {
      margin-bottom: 0;
    }

    .close {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      z-index: 100;
      right: -0.75em;
      top: -0.75em;
      width: 1.75em;
      height: 1.75em;
      padding: 0;
      border: none;
      font-size: 1.5em;
      background: $color-gray-200;
      color: $color-secondary-400;
      border-radius: 50%;
      box-shadow: $box-shadow-default;
      margin: 0;

      &:active {
        margin: 0;
      }
    }
  }
}
</style>